import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

function parseTravelJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(
    /("(?:contentId|creatorMemberId|linkedJourneyPublicationId|linkedLocationId|campaignId|creativeId|advertiserMemberId|destinationContentId|deliveryId|publicationId|postId|socialPostId|authorMemberId|memberId|quotedSocialPostId|locationId|parentLocationId)"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parseTravelJson] };

export const discoveryFeedApi = {
  getForYou: (params = {}, options = {}) => travelClient.get(travelEndpoints.discoveryFeed, {
    params: {
      feedSessionId: params.feedSessionId || undefined,
      cursor: params.cursor || undefined,
      limit: params.limit,
    },
    signal: options.signal,
    ...snowflakeJson,
  }),
  recordImpression: (body) => travelClient.post(travelEndpoints.discoveryFeedImpressions, body, snowflakeJson),
  recordBehavior: (body) => travelClient.post(travelEndpoints.discoveryFeedBehavior, body, snowflakeJson),
};
